export default __webpack_public_path__ + "static/media/Clientes (Real Size).2ec4048e.svg";